import type { TranslationMessages } from '../types';

export const salary_forecast: TranslationMessages = {
  title: 'Salary Forecast Report',
  subtitle: 'Forecast staff salaries based on scheduled shifts',
  export_report: 'Export Report',
  select_date_range: 'Select Date Range',
  choose_period: 'Choose the time period to forecast salaries',
  generate_report: 'Generate Report',
  loading_report: 'Loading Salary Forecast',
  fetching_data: 'Fetching shift and staff data...',
  failed_to_load: 'Failed to Load Report',
  try_again_message: 'Please try again or check your connection',
  total_forecasted: 'Total Forecasted Salary',
  staff_members: 'staff member |||| staff members',
  total_hours: 'Total Hours',
  scheduled_hours: 'Scheduled hours in period',
  average_daily: 'Average Daily Salary',
  per_day_average: 'Average per day',
  salary_chart: 'Salary Forecast Chart',
  chart_description: 'Daily salary forecast breakdown',
  salary: 'Salary',
  hours: 'Hours',
  staff_breakdown: 'Staff Salary Breakdown',
  staff_breakdown_description: 'Forecasted salary per staff member',
  no_shifts_found: 'No Shifts Found',
  no_shifts_message:
    'No scheduled shifts found for the selected time period',
  shifts: 'shift |||| shifts',
  daily_breakdown: 'Daily Breakdown',
  daily_breakdown_description: 'Daily salary forecast breakdown',
  no_data_found: 'No Data Found',
  no_data_message: 'No salary data found for the selected period',
  staff: 'staff member |||| staff members',
  full_time: 'Full-Time',
  shift_based: 'Shift-Based',
  vacation_days: 'vacation days',
  bonuses: 'bonuses',
  unpaid_absences: 'unpaid absences',
  vacation_pay: 'vacation pay',
  base_salary: 'Base salary included',
  };
